var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZatazeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    "data-name": "Vrstva 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190.65 108.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.08,108.39C13.39,108.42.34,98.6,0,84.86c-.18-7.41,3.11-14.09,9.45-18.9.24-3.48-.23-7.91.63-11.39,4.48-18.04,23.45-28.48,41.49-24.66C61.44,10.17,80.67-1.4,102.98.14c19.42,1.34,35.6,13.06,42.89,30.83,16-2.47,31.59,5.06,39.37,18.07s7.11,31.01-2.99,43.87c-6.71,8.54-18.02,15.23-29.7,15.25l-126.45.23ZM27,102.41l125.67-.3c11.95-.03,22.07-8.18,27.04-16.53,6.34-10.65,6.18-23.19.18-33.32-7.83-13.22-23.1-18.08-38.14-14.22-4.94-17.26-18.52-29-35.84-31.4-22.35-3.09-43.25,9.23-50.3,31.35-8.59-3.62-16.35-3.58-24.19.14-9.89,4.71-17.57,14.78-15.2,26.07.63,2.98.8,5.04-2.17,6.63-4.84,2.59-7.36,7.52-7.73,12.32-.89,11.64,10.59,19.29,20.68,19.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZatazeno);
export default __webpack_public_path__ + "static/media/zatazeno.bb7ae8fdc9876b061caa042e0b3fb4ca.svg";
export { ForwardRef as ReactComponent };